// extracted by mini-css-extract-plugin
export var actionButton = "_fn-t";
export var buttonContainer = "_fn-0";
export var buttonContainer2 = "_fn-1";
export var buttonSection = "_fn-2";
export var details = "_fn-3";
export var dropdownItem = "_fn-5";
export var dropdownItemsContainer = "_fn-4";
export var fileInput = "_fn-r";
export var headerButton = "_fn-6";
export var icon = "_fn-7";
export var input = "_fn-8";
export var macroListItem = "_fn-9";
export var mainContent = "_fn-a";
export var microText = "_fn-b";
export var modal = "_fn-w";
export var optionsButton = "_fn-c";
export var paperclip = "_fn-s";
export var pillContent = "_fn-d";
export var preview = "_fn-e";
export var preview2 = "_fn-f";
export var quillEditor = "_fn-q";
export var selectedMacro = "_fn-g";
export var sidebar = "_fn-h";
export var sidebarHeader = "_fn-j";
export var sidebarList = "_fn-i";
export var sidebarListItem = "_fn-k";
export var sidebarSearch = "_fn-l";
export var snoozeDurationWrapper = "_fn-v";
export var statusPillContainer = "_fn-m";
export var tagsContainer = "_fn-n";
export var unselectedMacro = "_fn-o";
export var variable = "_fn-u";
export var wrapper = "_fn-p";